import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {CommentCreate} from '../../shared/models/comment.model';
import {FormControl, FormGroup} from '@angular/forms';
import {DataStorageService} from '../../shared/services/data-storage.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-form-date-comment',
    templateUrl: './form-date-comment.component.html',
    styleUrls: ['./form-date-comment.component.css']
})
export class FormDateCommentComponent implements OnInit, OnDestroy {

    @Input() date: string;
    @Input() user_id: number;
    commentForm: FormGroup;

    private unsubscribe$: Subject<void> = new Subject<void>();

    constructor(private dataStorageService: DataStorageService) {
    }

    ngOnInit() {
        this.initForm();
    }

    initForm() {
        this.commentForm = new FormGroup({
            'comment': new FormControl()
        });
    }

    onSubmit() {
        const commentCreate = new CommentCreate(this.commentForm.get('comment').value, this.user_id);
        commentCreate.date = this.date;
        this.dataStorageService.createCommentDate(commentCreate)
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            responseData => {
                if (responseData['error']) {
                    console.log('saving comment error');
                } else {
                    alert('comment added. ');
                    location.reload();
                }
            }
        );
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

}
